<template>
	<el-popover placement="right" width="600" v-model="visible">
		<table-pagination
		    ref="customerTable"
		    pagination
		    :data="list"
		    :column="column"
		    :total="total"
		    :page.sync="listQuery.pageNum"
		    :limit.sync="listQuery.pageSize"
			v-loading="loading"
			 layout="total, prev, pager, next"
			@selection-change="handleSelectionChange"
		    @pagination="getList" />
		<div slot="reference" style="display: flex;">
			<slot></slot>
		</div>
		<div class="footer" style="float: right; ">
			<el-button @click="onCancel" size="mini">取 消</el-button>
			<el-button type="primary" @click="onSave" size="mini">确定</el-button>
		</div>
	</el-popover>
</template>

<script>
	export default {
		props:['type','childBrand','modelVal'],
		data() {
			return {
				searchVal:'',
				userType:'',
				list: [],
				loading:false,
				column:[
					 { label: '选择', prop: 'selection', type: 'selection',align:'left' },
					{
						label: '序号',
						width: 100,
						render: (h, scope) => {
							return <span>{((this.listQuery.pageNum - 1) * this.listQuery.pageSize) + (scope.$index + 1)}</span>
						}
					},
					{ 
						label: '昵称', 
						prop: 'nickname' ,
						renderHeader:(h,scope) => {
							return <el-input placeholder="请输入昵称"v-model={this.searchVal} clearable>
										<el-select v-model={this.userType} slot="prepend" placeholder="请选择坐席类型" clearable style="width:150px">
										  <el-option label="超级管理员" value="1"></el-option>
										  <el-option label="普通用户" value="0"></el-option>
										  <el-option label="品牌管理员" value="2"></el-option>
										</el-select>
										<el-button slot="append" icon="el-icon-search"  onClick={() => this.onSearch()}></el-button>
									</el-input>
						},
					},
				],
				total:1,
				listQuery:{
					pageNum:1,
					pageSize:8,
					brandIdentify:''
				},
				visible:false,
				multipleSelectionAll: [], // 所有选中的数据包含跨页数据
				multipleSelection: [], // 当前页选中的数据
				idKey: "userId", // 标识列表数据中每一行的唯一键的名称(需要按自己的数据改一下)
				
			}
		},
		watch: {
			visible(value){
				if(value){
					this.getList()
				}
			},
			modelVal(val){
				this.multipleSelectionAll = val;
				setTimeout(() => {
					this.setSelectRow();
				}, 20);
			},
		},
		methods: {
			onCancel(){
				this.visible = false;
				this.$refs.customerTable.$refs.elTable.clearSelection();
			},
			onSave(){
				this.changePageCoreRecordData();
				// if (this.multipleSelectionAll.length <= 0) {
				// 	this.$message({
				// 		message: "无勾选数据！",
				// 		type: "warning"
				// 	});
				// 	return;
				// }
				this.$emit('remoteTableData',{
					type:'自动分配',
					lists:this.multipleSelectionAll
				});
				this.visible = false;
			},
			onSearch(){
				this.listQuery.pageNum = 1;
				this.getList()
			},
			getList(val) {
				if(val){
					this.listQuery.pageNum = val.page
					this.changePageCoreRecordData();
				}
				switch(this.type){
					case '自动分配':
						this.getAutoEvent();
						break;
				}
			},
			handleSelectionChange(row){
				this.multipleSelection = row;
			},
			getAutoEvent(){
				this.loading = true;
				this.listQuery.brandIdentify = this.$store.getters.userInfo.brandIdentify;
				let params = {
					data: {
						brandIdentify:this.listQuery.brandIdentify,
					    nickname: this.searchVal,
					    userType: this.userType,
					},
					orderBy: null,
					pageNum: this.listQuery.pageNum,
					pageSize: this.listQuery.pageSize
				}
				if(this.childBrand){
					params.data.brandList = [this.childBrand];
				}
				this.$api.getAllPlatformUserList(params).then(res => {
					this.loading = false;
					if(res.errcode != 0) return;
					this.list = res.list;
					this.total = res.total;
					setTimeout(() => {
						this.setSelectRow();
					}, 20);
				})
			},
			//记忆选择核心方法
			changePageCoreRecordData(){
				// 标识当前行的唯一键的名称
				let idKey = this.idKey;
				let that = this;
				// 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
				if (this.multipleSelectionAll.length <= 0) {
					this.multipleSelectionAll = this.multipleSelection;
					return;
				}
				// 总选择里面的key集合
				let selectAllIds = [];
				this.multipleSelectionAll.forEach(row => {
					selectAllIds.push(row[idKey]);
				});
				let selectIds = [];
				// 获取当前页选中的id
				this.multipleSelection.forEach(row => {
					selectIds.push(row[idKey]);
					// 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
					if (selectAllIds.indexOf(row[idKey]) < 0) {
						that.multipleSelectionAll.push(row);
					}
				});
				let noSelectIds = [];
				// 得到当前页没有选中的id
				this.list.forEach(row => {
					if (selectIds.indexOf(row[idKey]) < 0) {
						noSelectIds.push(row[idKey]);
					}
				});
				noSelectIds.forEach(id => {
					if (selectAllIds.indexOf(id) >= 0) {
						for (let i = 0; i < that.multipleSelectionAll.length; i++) {
							if (that.multipleSelectionAll[i][idKey] == id) {
								// 如果总选择中有未被选中的，那么就删除这条
								that.multipleSelectionAll.splice(i, 1);
								i --
								break;
							}
						}
					}
				});
			},
			// 设置选中的方法
			setSelectRow() {
				if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
					return;
				}
				// 标识当前行的唯一键的名称
				let idKey = this.idKey;
				let selectAllIds = [];
			
				this.multipleSelectionAll.forEach(row => {
					selectAllIds.push(row[idKey]);
				});
				this.$refs.customerTable.$refs.elTable.clearSelection();
				for (var i = 0; i < this.list.length; i++) {
					if (selectAllIds.indexOf(this.list[i][idKey]) >= 0) {
						// 设置选中，记住table组件需要使用ref="table"
						this.$refs.customerTable.$refs.elTable.toggleRowSelection(this.list[i], true);
					}
				}
			}
		},
	}
</script>

<style scoped lang="scss">
	::v-deep {
		.pagination-container {
			padding: 0;
		}
	}
	
</style>
